import { useQueryClient } from '@tanstack/react-query';
import { useState } from 'react';
import { errorMessage } from '../../lib/errors';

/** Acción con aviso de éxito o error, y la recarga del ticket y de las listas. */
export function useAction() {
  const qc = useQueryClient();
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [notice, setNotice] = useState<string | null>(null);
  async function run(fn: () => Promise<unknown>, message: string | ((result: unknown) => string)) {
    setBusy(true);
    setError(null);
    setNotice(null);
    try {
      const result = await fn();
      setNotice(typeof message === 'function' ? message(result) : message);
      await qc.invalidateQueries({ queryKey: ['tickets'] });
    } catch (err) {
      setError(errorMessage(err));
    } finally {
      setBusy(false);
    }
  }
  return { busy, error, notice, run };
}
